import { render, staticRenderFns } from "./CNumber.vue?vue&type=template&id=3bed2646&scoped=true&"
import script from "./CNumber.vue?vue&type=script&lang=js&"
export * from "./CNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed2646",
  null
  
)

export default component.exports